<script>
import MasonryCards from '@/components/MasonryCards'

export default {
  name: 'ReportList',
  components: {
    MasonryCards
  },
  computed: {
    masonryCardData() {
      return Object.keys(this.formTypes)
        .filter(formType => /^_REPORT_/.test(formType))
        .map(formType => ({
          title: this.formTypes[formType].name,
          text: this.formTypes[formType].description,
          icon_right: 'angle-right',
          icon_right_tooltip: 'Open report',
          data: {
            name: 'runReport',
            params: { report: this.formTypes[formType].type, formType }
          }
        }))
    }
  },
  methods: {
    goToSite(data) {
      this.$router.push(data)
    }
  },
  mounted() {}
}
</script>

<template>
  <div>
    <transition name="y-slide" mode="out-in">
      <div :key="masonryCardData.length">
        <MasonryCards :content="masonryCardData" @bodyClick="goToSite" />
      </div>
    </transition>
  </div>
</template>

<style scoped></style>
